import { createFileRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';

const AdminImportWorkspace = lazy(() =>
  import('@/features/admin-terminal/components/admin-import-workspace').then(
    ({ AdminImportWorkspace: component }) => ({ default: component })
  )
);

export const Route = createFileRoute('/_admin/admin/imports')({
  component: () => (
    <Suspense fallback={null}>
      <AdminImportWorkspace />
    </Suspense>
  ),
});
